module.exports = __webpack_public_path__ + "img/notification.762bd5fb.svg";